<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :height="450"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form> </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="$refs.table.remove(row)"
            />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      tableColumns: tableColumns(this),
      editRules: {
        content: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
          {
            validator: ({ row }) => {
              const { componentPosition } = row
              const tableData = this.getTableData()


              const rows = tableData.filter(
                (row) => (row.componentPosition || '') === (componentPosition || '')
              )
              if (!rows?.length) return

              const totalContent = rows
                .map(({ content }) => content)
                .reduce((r, n) => add(r, n), 0)
              if (100 != totalContent) {
                return new Error(this.$l('INDEX.table_message_fabric_totalContent_noEq100%') || '当前面料位置成分总和不等于100%，请重新修改')
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    getTableData() {
      const data = this.$refs.table.getTableData()
      return data?.fullData || []
    },
    insertAt(records) {
      if (records?.length) return
      return this.$refs.table.insertAt(records, -1)
    },
    reloadData(data) {
      return this.$refs.table.reloadData(data)
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error(
          this.$l('INDEX.tips_error_fabricContent_empty') || '请选择面料成分'
        )
        return false
      }

      const result = await this.$refs.table.validate(true).catch(() => true)
      if (result) return false
      
      return true
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-table--render-default
    .vxe-body--row
    .vxe-body--column.content-cell
    .vxe-cell--valid {
    left: 100px;
  }
}
</style>
